
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <title>www.andreagt.com|Registro de cliente</title>

  <!-- Google Font: Source Sans Pro -->
  <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Source+Sans+Pro:300,400,400i,700&display=fallback">
  <!-- Font Awesome -->
  <link rel="stylesheet" href="/../../../assets/plugins/fontawesome-free/css/all.min.css">
  <!-- icheck bootstrap -->
  <link rel="stylesheet" href="/../../../assets/plugins/icheck-bootstrap/icheck-bootstrap.min.css">
  <!-- Theme style -->
  <link rel="stylesheet" href="/../../../assets/dist/css/adminlte.min.css">

  <style>

    .center {
        margin-left: auto;
        margin-right: auto;
        display: block;
        height:200px;
        width: 600px;
    }
    .centerdiv {
      margin-left: auto;
      margin-right: auto;
      
      text-align: center;
      background-color: black;
       
    }
</style>

</head>
<body class="hold-transition register-page">


  <div
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngStyle]="{'display':displayStyle}"> 
  <div class="modal-dialog" role="document"> 
    <div class="modal-content"> 
      <div class="centerdiv"  > 
        <img 
        src="./assets/dist/img/logo_andrea_log_up.jpg"  style="height: 85%;width: 75%;"
        alt="User profile picture">
      </div> 
      <h4 style="text-align: center; color: rgb(204, 11, 11);" >¡Felicidades, has quedado registrado!</h4> 
      <div class="modal-footer"  > 
        <div class="centerdiv">

          <button type="button" class="btn btn-danger" 
          (click)="onSubmitSesion()"> 
    Continuar 
  </button> 

        </div>
        
      </div> 
    </div> 
  </div> 
</div>




<div class="register-box">
  <div class="register-logo">
    <!-- <a href="#/inicio" style="height: 50px;"><b>www.andreagt.com</b></a> -->
     <h2 style="font-size: 40px;color: rgb(73, 73, 73);">www.andreagt.com</h2>
  </div>

  <div class="card">
    <div class="card-body register-card-body">
      <p class="login-box-msg">Por favor, llena los siguientes campos, para generar tu CODIGO CLIENTE.</p>

      <form  [formGroup]="formRegistroCliente">
        <h4 class="mt-3" style="color: #0A0A0A"> Nombre<small></small></h4>
        <div class="input-group mb-3" >
         
          <input type="text" class="form-control" style="font-size: 24px;height: 52px;color: #0A288A;"  formControlName="txtNombre" autocomplete="off" >
          <div class="input-group-append">
            <div class="input-group-text">
              <span class="fas fa-user"></span>
            </div>
          </div>
         

        </div>

        <div *ngIf="errorForm[0] == '1'">
          <label for="label1"><code>Debe indicar un Nombre.</code></label>
        </div>


        <h4 class="mt-3" style="color: #0A0A0A"> Apellido<small></small></h4>
        <div class="input-group mb-3" >
       
            <input type="text" class="form-control"style="font-size: 24px;height: 52px;color: #0A288A;"  #code formControlName="txtApellido" autocomplete="off"   >
            <div class="input-group-append">
              <div class="input-group-text">
                <span class="fas fa-user"></span>
              </div>
            </div>
           
        </div>
        <div *ngIf="errorForm[1] == '1'">
          <label for="label1"><code>Debe indicar un Apellido.</code></label>
        </div>

        <h4 class="mt-3" style="color: #0A0A0A"> Teléfono<small></small></h4>

        <div class="input-group  mb-3" >
            <div class="input-group-prepend">
              <span class="input-group-text">(502)</span>
            </div>
            <input type="text" class="form-control"   mask="0000-0000" formControlName="txtMovil" autocomplete="off" inputmode="numeric" style="font-size: 24px;height: 52px;color: #0A288A;">
          
        </div>
        <div *ngIf="errorForm[2] == '1'">
          <label for="label1"><code>Debe indicar número de teléfono.</code></label>
        </div>
        <h4 class="mt-3" style="color: #0A0A0A"> Correo Electrónico<small></small></h4>
        <div class="input-group mb-3" >
          <input type="text" class="form-control" #code formControlName="txtCorreo" autocomplete="off"  style="font-size: 24px;height: 52px;color: #0A288A;" >
          <div class="input-group-append">
            <div class="input-group-text">
              <span class="fas fa-message"></span>
            </div>
          </div>
         
      </div>

        <div class="row">
          <div class="col-9">
            <div class="icheck-primary">
              <input type="checkbox"  id="agreeTerms" name="terms" value="agree"  [(ngModel)]="checkBoxValue" [ngModelOptions]="{standalone: true}" (change)="checkCheckBoxvalue()" style="height: 48px;width: 48px;font-size: x-large;">
              <label for="agreeTerms" style="font-size: 22px;">
               Acepto los  <a style="padding-top: 0.50em;
padding-bottom: 0.50em;" href="#/privacity">terminos.</a>
              </label>
            </div>
          </div>

          <div *ngIf="errorForm[3] == '1'">
            <label for="label1"><code>Debe aceptar los términos.</code></label>
          </div>
<br>
<br>
          <!-- /.col -->
          <div style="justify-content: center;align-items: center;">
            <button type="button" class="btn btn-danger btn-block" (click)="OnRegistraCliente()" style="font-size: 23px;background-color:#d40606;">Registrar</button>
          </div>
       
          <div>
            <br>
          </div>

          <div style="justify-content: center;align-items: center;">
            <button type="button" class="btn btn-primary btn-block" (click)="OnIraInicio()" style="font-size: 23px;background-color: #0058db;">Inicio</button>
          </div>
          <!-- /.col -->
        </div>
      </form>

      <div class="social-auth-links text-center">
        <div *ngIf="lblRespuesta == false">
          <label for="label1"><code>El numero de móvil, ya esta registrado..</code></label>
        </div>

        <div *ngIf="esperar == true" class="overlay"><i class="fas fa-3x fa-sync-alt fa-spin"></i><div class="text-bold pt-2">Cargando...</div></div>

      </div>

  

      
    
    </div>
    <!-- /.form-box -->
  </div><!-- /.card -->
</div>
<!-- /.register-box -->

<!-- jQuery -->
<script src="../../plugins/jquery/jquery.min.js"></script>
<!-- Bootstrap 4 -->
<script src="../../plugins/bootstrap/js/bootstrap.bundle.min.js"></script>
<!-- AdminLTE App -->
<script src="../../dist/js/adminlte.min.js"></script>


<script>
    
  $(function () {


  //Money Euro
  $('[data-mask]').inputmask()

 

})






</script>



</body>
</html>
